<div class="content mt-3">
    <div class="row">
        <div class="col-lg-12">
            <div class="card">
                <div class="card-header cardheader">
                    <div class="col-12">
                        <h1 class="heading">Common Sms Setting</h1>
                    </div>
                </div>
                <div class="card-body pt-0">
                    <div class="container-fluid">
                        <div class="row border-bottom py-3 d-flex justify-content-center align-items-center" *ngFor="let Sms_data of smsData;let index = index;">
                            <div class="col-lg-2">
                                <div class="form-group mb-0">
                                    <p class="capitalize m-0">{{Sms_data.key_text.replace('_', ' ').replace('_', ' ')}}</p>
                                </div>
                            </div>
                            <div>
                                <div class="form-group mb-0">
                                    <mat-slide-toggle [checked]="Sms_data.key_value=='1'"
                                        (change)="onKeyValueChange($event,Sms_data.key_text,index)"></mat-slide-toggle>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>